module.exports = __webpack_public_path__ + "static/matza_3@1x-63542f883d93ec8414591d78c9a85ac5.jpg";